import { useFlag } from '@unleash/proxy-client-react';
import { FormattedMessage } from 'react-intl';
import { FeatureToggle } from 'utils/unleash/toggles';

import { Tooltip } from 'components';

import { HistoryResumeItemProps } from './types';

import * as S from './styles';

const HistoryResumeItem: React.FC<HistoryResumeItemProps> = ({
  icon,
  title,
  amount,
  dataKey,
  tooltip,
  loading,
  accepted,
}) => {
  const isRescheduleToggleEnabled = useFlag(FeatureToggle.Reschedule);
  const isShowLabel =
    isRescheduleToggleEnabled && accepted !== undefined && amount !== undefined;

  const largeItem = !icon;

  return (
    <S.SessionsContainer largeItem={largeItem}>
      {!largeItem && (
        <S.IconsContainer data-testid="icon-container">
          <S.StyledIcon as={icon} />
        </S.IconsContainer>
      )}

      <S.SessionTextContainer data-testid="session-text-container">
        <S.SessionTextSubContainer>
          <S.SessionsSubTitle>
            <FormattedMessage id={title} />
          </S.SessionsSubTitle>
          {tooltip && (
            <S.TooltipContainer data-testid="session-tooltip-container">
              <Tooltip description={tooltip}>
                <S.StyledInfo data-testid="tooltip-icon" />
              </Tooltip>
            </S.TooltipContainer>
          )}
        </S.SessionTextSubContainer>

        {loading ? (
          <S.FieldSkeleton data-testid="loading" />
        ) : (
          <>
            {largeItem ? (
              <S.SessionsLarge data-testid={dataKey}>{amount}</S.SessionsLarge>
            ) : (
              <S.SessionsSmall data-testid={dataKey}>{amount}</S.SessionsSmall>
            )}
          </>
        )}

        {isShowLabel && (
          <S.LabelText>
            <FormattedMessage
              id={
                amount > 1
                  ? 'CPPLATAFORM.CPNEWTIME.PLATFORMSUBTITLE'
                  : 'CPPLATAFORM.CPNEWTIME.PLATFORMSUBTITLESINGULAR'
              }
              values={{ number: accepted, total: amount }}
            />
          </S.LabelText>
        )}
      </S.SessionTextContainer>
    </S.SessionsContainer>
  );
};

export default HistoryResumeItem;
